import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

export function withRouter(Children) {
    return (props) => {
        const location = useLocation();
        const navigate = useNavigate();

        const history = useMemo(() => {
            return Object.assign(navigate, {
                location: location,
                goBack: () => navigate(-1),
            });
        }, [navigate]);
        return <Children {...props} history={history} location={location} />;
    };
}
